import React from 'react'
import { Box, CircularProgress, Typography } from '@mui/material'
import { LoadingState } from 'src/Libs/chart-kit'
import { makeStyles } from 'tss-react/mui'
import { CHART_LOADING_BACKDROP_ID } from 'src/Libs/qa/ids'

const useStyles = makeStyles()(theme => ({
  container: {
    minHeight: 70,
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'rgba(115, 115, 115, 0.20)',
    borderRadius: theme.shape.borderRadius,
    zIndex: theme.zIndex.appBar - 1,
  },
  content: {
    padding: theme.spacing(4),
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.effectStyles.shadowMain,
    position: 'sticky',
    top: '50%',
    width: 'max-content',
    margin: theme.spacing(4, 'auto'),
  },
}))

/* Fallback values are necessary to avoid layout shift because of data not being available instantly */
const FALLBACK_TOTAL = 3
const FALLBACK_FETCHED = 0

/**
 * Component that displays a loading backdrop for charts.
 * It shows a spinner and a percentage of fetched months if available.
 */
const ChartLoadingBackdrop: React.FC<{ loadingState: LoadingState }> = ({ loadingState: { fetchedMonths, monthAmountToFetch } }) => {
  const { classes } = useStyles()

  return (
    <Box className={classes.container} data-qa={CHART_LOADING_BACKDROP_ID}>
      <Box className={classes.content}>
        <CircularProgress size={30} />
        <ValueAsPercentage value={fetchedMonths || FALLBACK_FETCHED} total={monthAmountToFetch || FALLBACK_TOTAL} />
      </Box>
    </Box>
  )
}

export default ChartLoadingBackdrop

const ValueAsPercentage: React.FC<{ value: number; total: number }> = ({ value, total }) => {
  const percentage = total > 0 ? Math.round((value / total) * 100) : 0

  return (
    <Typography variant="h5" mt={1}>
      {percentage}%
    </Typography>
  )
}
